import { dashboard, dashboardError, news } from '@/store/dashboard';
import { formatDate } from '@/utils/format';
import { PushToggle } from '@/features/pwa/PushToggle.jsx';
import css from './Dashboard.module.css';

export function Dashboard() {
  const partner = dashboard.value;
  const err = dashboardError.value;
  const newsItems = news.value;

  if (err) {
    return <div class="empty-state">Ошибка: {err.message}</div>;
  }
  if (!partner) {
    return <p class="loading">Загрузка</p>;
  }

  const discount = computeDiscount(partner);

  return (
    <>
      <section class="panel">
        <h2 class="panel-title">Карточка партнёра</h2>
        <p>
          <strong>{partner.name ?? '—'}</strong>
        </p>
        <p>
          ИНН: {partner.inn ?? 'n/a'} | КПП: {partner.kpp ?? 'n/a'}
        </p>
        {(partner.manager_name || partner.manager_phone || partner.manager_email) && (
          <p>
            Менеджер:{' '}
            {[partner.manager_name, partner.manager_phone, partner.manager_email]
              .filter(Boolean)
              .join(' · ')}
          </p>
        )}
        {discount && <p>Скидка: {discount}</p>}
      </section>

      <PushToggle />

      <section class="panel">
        <h3 class="panel-title">Новости</h3>
        {newsItems.length === 0 ? (
          <p class="empty-state">Нет новостей</p>
        ) : (
          <div class={css.newsGrid}>
            {newsItems.map((item) => (
              <article key={item.id ?? item.title} class={css.newsCard}>
                <h3 class={css.newsTitle}>{item.title ?? ''}</h3>
                <p class={css.newsBody}>{item.body ?? ''}</p>
                <small class={css.newsDate}>{formatDate(item.published_at)}</small>
              </article>
            ))}
          </div>
        )}
      </section>

      <section class="panel">
        <h3 class="panel-title">Адрес доставки</h3>
        {partner.addresses?.length > 0 ? (
          <ul class={css.addressList}>
            {partner.addresses.map((a) => (
              <li key={a.id}>{a.address}</li>
            ))}
          </ul>
        ) : (
          <p class="empty-state">Адреса не добавлены</p>
        )}
      </section>

      <section class="panel">
        <h3 class="panel-title">Контактные лица</h3>
        {partner.contacts?.length > 0 ? (
          <ul>
            {partner.contacts.map((c) => {
              const parts = [];
              if (c.position) parts.push(c.position);
              if (c.phone) parts.push(`тел: ${c.phone}`);
              if (c.email) parts.push(c.email);
              return (
                <li key={c.id ?? c.name}>
                  {c.name}
                  {parts.length > 0 && ` — ${parts.join(', ')}`}
                </li>
              );
            })}
          </ul>
        ) : (
          <p class="empty-state">Контакты не добавлены</p>
        )}
      </section>
    </>
  );
}

function computeDiscount(partner) {
  if (partner.use_custom_discount && (partner.discount_percent ?? 0) > 0) {
    return `-${partner.discount_percent}%`;
  }
  const match = (partner.price_type_name ?? '').match(/\((-?\d+)%?\)/);
  if (match) return `${match[1]}%`;
  if ((partner.discount_percent ?? 0) > 0) return `-${partner.discount_percent}%`;
  return null;
}
